import styled from "styled-components";

export const Nav = styled.nav`
  background: #272727;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.2rem;
  position: sticky;
  top: 0;
  z-index: 999;
  border-bottom: 2px solid ${({ moved }) => (moved ? "#828282" : "none")};
  padding-left: 30px;
  padding-right: 30px;
`;

export const NavbarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  height: 80px;
  width: 100%;
  max-width: 1300px;
`;

export const NavLogo = styled.a`
  color: #e7ebda;
  justify-self: flex-start;
  cursor: pointer;
  text-decoration: none;
  font-size: 1.5rem;
  display: flex;
  align-items: center;

  @media screen and (max-width: 320px) {
    font-size: 1.25rem;
  }
`;

export const NavIcon = styled.img`
  width: 4rem;
  @media screen and (max-width: 960px) {
    width: 3rem;
    @media screen and (max-width: 320px) {
      width: 2.5rem;
    }
  }
`;

export const MobileIcon = styled.div`
  display: none;

  svg {
    fill: ${({ light }) => (light ? "#f7f8fa" : "#e7ebda")};
  }

  @media screen and (max-width: 1015px) {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(-100%, 60%);
    font-size: 1.8rem;
    cursor: pointer;
  }
`;

export const NavMenu = styled.ul`
  display: flex;
  align-items: center;
  list-style: none;
  text-align: center;

  @media screen and (max-width: 1015px) {
    display: flex;
    flex-direction: column;
    position: absolute;
    width: 100%;
    height: 90vh;
    top: 80px;
    left: ${({ click }) => (click ? 0 : "-100%")};
    opacity: 1;
    transition: all 0.5s ease;
    background: ${({ light }) => (light ? "#454546" : "#0a0806")};
  }
`;

export const NavItem = styled.li`
  height: 80px;
  border-bottom: 2px solid transparent;
  &:hover {
    border-bottom: 4px solid ${({ light }) => (light ? "#e57373" : "#5dc1b9")};
  }

  @media screen and (max-width: 960px) {
    width: 100%;
    &:hover {
      border: none;
    }
  }
`;

export const NavLinks = styled.a`
  color: #e7ebda;
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 0.5rem 1rem;
  height: 100%;
  font-family: "Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande",
    "Lucida Sans", Arial, sans-serif;
  font-weight: bold;
  font-size: 18px;

  &.active {
    color: ${({ light }) => (light ? "#e57373" : "#5dc1b9")};
  }

  &:hover {
    color: ${({ light }) => (light ? "#e57373" : "#5dc1b9")};
  }

  @media screen and (max-width: 1050px) {
    font-size: 14.5px;

    @media screen and (max-width: 1015px) {
      font-size: 18px;
      &.active {
        color: white;
      }
      text-align: center;
      padding: 2rem;
      width: 100%;
      display: table;
      &:hover {
        color: #009c8c;
        transition: all 0.6s ease;
      }
    }
  }
`;

export const NavItemBtn = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-left: 15px;

  .switch {
    svg {
      fill: ${({ checked }) => (checked ? "#5dc1b9" : "#ebe1c9")};
      margin-top: 4px;
      margin-left: 8px;
      width: 15px;
    }
  }

  @media screen and (max-width: 960px) {
    margin-top: 20px;
  }
`;

export const NavBtnLink = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  padding: 8px 16px;
  height: 100%;
  width: 100%;
  outline: none;
`;
